<div class="header header-admin d-none d-md-flex flex-row align-items-center">
    <ng-container *ngIf="back">
        <app-arrow-left (click)="redirect()"></app-arrow-left>
    </ng-container>

    <ng-container *ngIf="isUsingBackpageService">
        <app-arrow-left (click)="goBackPage()"></app-arrow-left>
    </ng-container>

    <span [translate]="h1"></span>
    <ng-container *ngIf="show">
        <div class="search-container">
            <ng-container *ngIf="!quickSelect">
                <input [formControl]="searchControl" [placeholder]="'search' | translate" class="search" type="text" />
            </ng-container>
            <ng-container *ngIf="quickSelect">
                <input
                    onMouseEnter="focus()"
                    [formControl]="searchControl"
                    [placeholder]="'search' | translate"
                    (input)="selectPatient($event)"
                    class="search"
                    list="patients"
                    type="text"
                    autocomplete="off"
                />
                <datalist id="patients">
                    <ng-container *ngIf="patients?.length > 0">
                        <option *ngFor="let patient of patients">
                            {{
                                normalizeNames(patient.lastName.toUpperCase()) +
                                    ' ' +
                                    normalizeNames(capitalizeFirstLetter(patient.firstName)) +
                                    ' - ' +
                                    (patient.birthDate | date : 'dd/MM/YYYY')
                            }}
                            <ng-container *ngIf="typeNumber">
                                <span *ngIf="patient.socialSecurityNumber.includes(searchControl.value)">
                                    {{ ' - nir: ' + patient.socialSecurityNumber }}
                                </span>
                                <span *ngIf="patient.ins?.includes(searchControl.value)">
                                    {{ ' - ins: ' + patient.ins }}
                                </span>
                                <span *ngIf="patient?.ipp && patient.ipp?.includes(searchControl.value)">
                                    {{ ' - ipp: ' + patient.ipp }}
                                </span>
                            </ng-container>
                        </option>
                    </ng-container>
                </datalist>
            </ng-container>
            <ng-container *ngIf="!searchText">
                <app-search (click)="search()" class="search-container__icon"></app-search>
            </ng-container>
            <ng-container *ngIf="searchText">
                <app-close (click)="cleanSearch()" [active]="false" class="search-container__icon"></app-close>
            </ng-container>
        </div>
    </ng-container>

    <div class="d-flex content">
        <ng-content></ng-content>
    </div>
</div>

<ng-container *ngIf="show">
    <div [class]="color" class="mobile-search d-flex d-md-none align-items-center">
        <ng-container *ngIf="!showSearchbar; else searchBar">
            <div>
                <app-mobile-kebab-menu class="menu" (click)="toggleSidebar()"></app-mobile-kebab-menu>
                <span [translate]="h1"></span>
                <app-search (click)="showSearchbar = !showSearchbar"></app-search>
                <ng-container *ngIf="searchText">
                    <app-close [active]="true"></app-close>
                </ng-container>
            </div>
        </ng-container>

        <ng-template #searchBar>
            <app-arrow-left (click)="showSearchbar = !showSearchbar; cleanSearch()" [disabled]="true"></app-arrow-left>
            <input class="search" type="text" [formControl]="searchControl" [placeholder]="'search' | translate" />
            <div class="clean">
                <ng-container *ngIf="searchText">
                    <app-close [active]="true" (click)="cleanSearch()"></app-close>
                </ng-container>
            </div>
        </ng-template>
    </div>
</ng-container>

<ng-container *ngIf="!show">
    <div [class]="color" class="header-mobile d-flex d-md-none flex-row align-items-center">
        <app-mobile-kebab-menu class="menu" (click)="toggleSidebar()"></app-mobile-kebab-menu>
        <ng-container *ngIf="back">
            <app-arrow-left (click)="redirect()" class="ms-2"></app-arrow-left>
        </ng-container>
        <span [translate]="h1" class="ms-3"></span>
        <ng-container *ngIf="profile">
            <div class="lng">
                <mat-form-field appearance="outline">
                    <mat-select [(ngModel)]="selected" (selectionChange)="changeLanguage($event)">
                        <mat-select-trigger>
                            <img width="22" [src]="selected.img" alt="selected-flag" />
                        </mat-select-trigger>
                        <mat-option *ngFor="let lang of languages" [value]="lang">
                            <img alt="flag" width="24" [src]="lang.img" />
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>
    </div>
</ng-container>
